export default "__VITE_ASSET__wKUi5Bkk__"